import React, { useState, useEffect, useRef } from 'react';
import { TextField, Button, Typography, Paper, Grid, Switch, withStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
// import FileBase from 'react-file-base64';
// import { IconButton, Divider } from '@material-ui/core';
import { v4 as uuidv4 } from 'uuid';
import { getSignature } from '../../../api';
import { createPost } from '../../../actions/posts';
import useStyles from './styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import SearchIcon from '@material-ui/icons/Search';
import { addToVisited } from '../../../actions/favorites';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import MaxWidthDialog from './TagDialog';

const CreatePhotoForm = () => {
  const date = new Date();
  // const date = formatDistance(subDays())
  const history = useHistory();
  // console.log(date);
  const [postData, setPostData] = useState({id:'', type:'', title: '', caption:'', summary:'', photoURL:'', videoURL:'', message: '', content:'', tags: '', selectedFile: '', placeName:'', location:'', coordinates: '', createdAt:'', tags:[] });
  // const post = useSelector((state) => (postId ? state.posts.find((message) => message._id === postId) : null));
  const [location, setLocation] = useState({ placeName:'', locName:'', country:'', location:'', latitude :'', longitude: '', coordinates: ''});
  const [selectedTags, setselectedTags] = useState([]);
  const [image, setImage] = useState(null);
  // console.log(location.placeName);
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = JSON.parse(localStorage.getItem('profile'));
  const [visitedLocation, setVisitedLocation] = useState({ placeName:'', name:'', country:'', location:'', latitude :'', longitude: '', coordinates: ''});
  const [switchState, setSwitchState] = useState(true);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snack, setSnack] = useState('');
  // console.log(location);
  // console.log(postData);
 
  ////Location States/////////////////
 
  const [place, setPlace] = 
    useState({name:'',
              // id:'',
              // address:'',
              photos:[]
  });
  const [query, setQuery] = useState("");
  const [city, setCity] = useState("")
  const autoCompleteRef = useRef(null);
  // console.log(place);

  let autoComplete;

  const loadScript = (url, callback) => {
  let script = document.createElement("script");
  script.type = "text/javascript";

  if (script.readyState) {
    script.onreadystatechange = function() {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};

const handleScriptLoad = () => {
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    // { 
    //   // types: ["(cities)"],
    //  componentRestrictions: { country: "lk" } }
  );
  // autoCompleteRef.current.setFields(["address_components", "formatted_address", 'place_id', 'geometry', 'name', 'photos']);
  autoCompleteRef.current.addListener("place_changed", handlePlaceSelect);
}

const handlePlaceSelect = () => {
  const addressObject = autoCompleteRef.current.getPlace();
  const name = addressObject.name;
  const countryString = addressObject.adr_address.substring(addressObject.adr_address.lastIndexOf("<span class=\"country-name\">"), addressObject.adr_address.lastIndexOf("<"));
  const country = countryString.split(">")[1];
  let placeName;
  if(name === country) {
    placeName = name;
  } else {
    placeName = name + "," + " " + country;
  }
  // const photos = addressObject.photos;
  const long_name = addressObject.address_components.map(addressComponent => addressComponent.long_name);
  const long_name_str = long_name.toString();
  const latitude = (addressObject.geometry.location.lat());
  const longitude = (addressObject.geometry.location.lng());
  const coordinates = addressObject.geometry.location.lat() + ', ' + addressObject.geometry.location.lng();
  const latitude_str = (addressObject.geometry.location.lat()).toString();
  const longitude_str = (addressObject.geometry.location.lng()).toString();
  // console.log(addressObject); 
  // updateQuery(query);
  // setPlace({...place, name:name, photos: photos});
  // setPostData({...postData, location:long_name_str})
  setLocation({...location, location:long_name_str, latitude:latitude, longitude:longitude, coordinates:coordinates, placeName:placeName, locName:name, country:country})
  setQuery(placeName);
  setVisitedLocation({...visitedLocation, location:long_name_str, latitude:latitude_str, longitude:longitude_str, coordinates:coordinates, placeName:placeName, name:name, country:country})

  // console.log(addressObject);
  // console.log(placeName);
  // setPlace({...place, });
}
 
useEffect(() => {
  loadScript(
    `https://maps.googleapis.com/maps/api/js?key=AIzaSyDXGCxkxHNNK_ZO18wSSJlcwCA242XZuqk&callback=initMap&libraries=places`,
    () => handleScriptLoad(setQuery, autoCompleteRef)
  );
}, []);
  /////////////////////////////////////

  // useEffect(() => {
  //   if (post) setPostData(post);
  // }, [post]);
  

  const clear = () => {
    // setCurrentId(0);
    // handleClose();
    setPostData({id:'', type:'', title: '', caption:'', summary:'', photoURL:'', videoURL:'', message: '', content:'', tags: '', selectedFile: '', placeName:'', location:'' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(postData.photoURL === '') {
      setSnack('E1');
      setSnackOpen(true);
      return;
    }

    if(location.coordinates === '') {
      setSnack('E2');
      setSnackOpen(true);
      return;
    }

    if(switchState) {
      dispatch(createPost
        ({ ...postData, id: uuidv4(), type:'Photo', name: user?.result?.name, placeName:location.placeName,locName:location.locName, country:location.country, location:location.location, latitude:location.latitude, longitude:location.longitude, coordinates:location.coordinates, createdAt:date, tags:selectedTags, generalTags:selectedTags.filter(tag => (tag.tagType === 'General')), AVTags:selectedTags.filter(tag => (tag.type === 'AVTags')), activityTags:selectedTags.filter(tag => (tag.type === 'Activities')), vibeTags:selectedTags.filter(tag => (tag.type === 'Vibes') && tag.label) }, visitedLocation, history ));
    } else {
      dispatch(createPost
        ({ ...postData, id: uuidv4(), type:'Photo', name: user?.result?.name, placeName:location.placeName,locName:location.locName, country:location.country, location:location.location, latitude:location.latitude, longitude:location.longitude, coordinates:location.coordinates, createdAt:date, tags:selectedTags, generalTags:selectedTags.filter(tag => (tag.tagType === 'General')), AVTags:selectedTags.filter(tag => (tag.type === 'AVTags')), activityTags:selectedTags.filter(tag => (tag.type === 'Activities')), vibeTags:selectedTags.filter(tag => (tag.type === 'Vibes') && tag.label) }, null, history ));
    }
    setSnack('S1')
    setSnackOpen(true);
    clear();
  };

  if (!user?.result?.name) {
    return (
      <Paper className={classes.paper}>
        <Typography variant="h6" align="center">
          Sign In to create your own memories and like other's memories.
        </Typography>
      </Paper>
    );
  }

  /////////////Location Tagging////////////
  let myWidget;
  const MyWidget = () => {
    myWidget = window.cloudinary.createUploadWidget(
      {
        cloud_name: 'travelaio',
        api_key: '222487881423418',
        // public_id:'ohHiMark',
        uploadPreset: "postPhoto",
        fetch_format: "auto",
        multiple:"false",
        cropping: true,
        croppingAspectRatio:1,
        thumbnails:'.thumbnail', 
        autoUpload:'false',
        thumbnailTransformation: [{ width: 250, height: 250, crop:'limit' }],
        upload_signature: generateSignature,
      },
      (error, result) => {
        if (!error && result && result.event === "success") {
          // console.log("Done! Here is the image info: ", result.info);
          const url = result.info.secure_url;
          const urlPos = url.indexOf('upload/') + 7;
          const photourl = url.substring(0, urlPos) + "f_auto/" + url.substring(urlPos, url.length)
          // console.log(photourl);
          setPostData({...postData, photoURL:photourl});
          setImage(result.info.original_filename + '.' + result.info.format)
          // console.log(postData);
        } else if(error) {
          // console.log(error);
          // console.log(result);
        }
      }
    );

    const handleWidget = (e) => {
      e.preventDefault();

        setImage(null);
      myWidget.open();
    }

    return (
      <>
      <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', margin:'auto', marginBottom:'15px', marginTop:`${image && '30px'}`}}>
      {(image) && 
      <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
        <p style={{marginLeft:"5px", marginRight:'5px'}}>Photo Added</p>
        <CheckCircleIcon style={{color:'green'}} />
      </div>
      }
      {!image ? 
      <Button id="upload_widget" className="cloudinary-button" variant="contained" color="primary" size="medium" onClick={handleWidget}>
        Add Photo
      </Button>
      : 
      <Button id="upload_widget" className="cloudinary-button" variant="contained" color="secondary" size="small" onClick={() => myWidget.destroy({ removeThumbnails: true }).then(() => setImage(null))}>
        Remove Photo
      </Button>
      }
      {/* <p style={{marginLeft:'20px'}}>{image}</p> */}
      </div>
      </>
    )
  }

  const generateSignature = async (callback, params_to_sign) => {
    try {
      const signature = await getSignature(params_to_sign);
      callback(signature.data);
      // console.log(signature.data);
      // console.log(params_to_sign);
      // console.log(callback);
    } catch (error) {
      console.log(error);
    }
  };  



  const VisitSwitch = withStyles({
    switchBase: {
      color: '#ffffff',
      '&$checked': {
        color: '#04cf1c',
      },
      '&$checked + $track': {
        backgroundColor: '#04cf1c',
      },
    },
    checked: {},
    track: {},
  })(Switch);

  const handleVisitSwitch = () => {
    setSwitchState(switchState => !switchState);

  }

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }


  return (
    // <Paper className={classes.paper}>
    <>
    <div class="thumbnail" style={{height:`${image ? '250px' : '5px'}`, width:'250px', display:'flex', margin:'auto'}}></div>
      <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit} onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }} >
        
      <MyWidget />
      <div style={{width:'100%'}}>
        <Typography style={{marginLeft:'10px', color:'#333'}}>Add a Caption</Typography>
      </div>
        <TextField style={{marginBottom:'15px'}} name="caption" variant="outlined" fullWidth value={postData.caption} onChange={(e) => setPostData({ ...postData, caption: e.target.value })} />
        <MaxWidthDialog selectedTags={selectedTags} setselectedTags={setselectedTags} />
        {/* <TextField name="message" variant="outlined" label="Message" fullWidth multiline rows={4} value={postData.message} onChange={(e) => setPostData({ ...postData, message: e.target.value })} /> */}
        {/* <TextField name="tags" variant="outlined" label="Tags (coma separated)" fullWidth value={postData.tags} onChange={(e) => setPostData({ ...postData, tags: e.target.value.split(',') })} /> */}
      <div style={{width:'100%'}}>
        <Typography style={{marginLeft:'10px', color:'#333'}}>Add Location</Typography>
      </div>
        <div id="tinyInput" className="search-location-input" style={{display:"flex", justifyContent:'center',  alignItems:'center', height:'49px', width:'100%', margin:'auto', marginTop:'10px'}}>
      <SearchIcon style={{backgroundColor:'white', borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px', border:'1px solid silver', borderRight:'0', padding:'12px', fontSize:'3.1rem'}}/>
      <input
        ref={autoCompleteRef}
        onChange={event => setQuery(event.target.value)}
        placeholder="Enter a location"
        value={query}
      />
       {/* <Button variant="contained" style={{ marginLeft:'10px'}} color="primary">
            Search
        </Button> */}
      {/* <p>{place}</p> */}      
    </div>
    <Grid container style={{display:'flex', alignItems:'center', marginTop:'10px'}}>
      <Grid item>
        <VisitSwitch
          checked={switchState}
          onChange={handleVisitSwitch}
          // color="primary"
          // name="checkedB"
          // inputProps={{ 'aria-label': 'primary checkbox' }}
          // style={{color:'red'}}
        />
      </Grid>
      <Grid item>
        <Typography>Mark this location as visited.</Typography>
      </Grid>
    </Grid>

      
      
        <div className={classes.fileInput}>
        
          {/* <FileBase type="file" multiple={false} onDone={({ base64 }) => setPostData({ ...postData, selectedFile: base64 })} /> */}
          </div>
        {/* <Button style={{ marginLeft:'auto'}} className={classes.buttonSubmit} variant="contained" color="primary" size="small" type="submit">Post</Button> */}
        
          <Button variant="contained" style={{ marginLeft:'auto'}} color="secondary">
            Cancel
          </Button>
          <Button style={{ marginLeft:'10px'}} variant="contained" type="submit" color="primary">
            Post
          </Button>
      </form>
      {snack === 'S1' && (
      <Snackbar open={snackOpen} autoHideDuration={5000} onClose={() => setSnackOpen(false)}>
        <Alert onClose={() => setSnackOpen(false)} severity="success">
          Creating Your Post ...
        </Alert>
      </Snackbar>
      )}
      {snack === 'E1' && (
      <Snackbar open={snackOpen} autoHideDuration={5000} onClose={() => setSnackOpen(false)}>
        <Alert onClose={() => setSnackOpen(false)} severity="error">
          Photo not added.
        </Alert>
      </Snackbar>
      )}
      {snack === 'E2' && (
      <Snackbar open={snackOpen} autoHideDuration={5000} onClose={() => setSnackOpen(false)}>
        <Alert onClose={() => setSnackOpen(false)} severity="error">
          Please select a location.
        </Alert>
      </Snackbar>
      )}
      </>
    // </Paper>
  );
};

export default CreatePhotoForm;
